import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import jatelindoLogo from "assets/images/jatelindo-logo.png";
import felloLogo from "assets/images/fello-logo.png";
import TwitterIcon from "assets/icons/social-media/TwitterIcon";
import FacebookIcon from "assets/icons/social-media/FacebookIcon";
import InstagramIcon from "assets/icons/social-media/InstagramIcon";
import LinkedinIcon from "assets/icons/social-media/LinkedinIcon";
import YoutubeIcon from "assets/icons/social-media/YoutubeIcon";

function Footer({ isEnglish, handleSwitchLanguage }) {
  const { t } = useTranslation();

  const handleOpenNewTab = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="text-white bg-app-blue">
      <div className="flex flex-col justify-between gap-6 app-nav-container sm:flex-row sm:gap-0">
        <div className="grid grid-cols-1 gap-6 text-sm sm:grid-cols-3 sm:gap-12 sm:text-base">
          <ul className="space-y-2">
            <li>
              <a href="/about">{t("aboutUs")}</a>
            </li>
            <li>
              <a href="/sponsors">{t("ourSponsors")}</a>
            </li>
            <li>
              <a href="/prices">{t("ticketPrice")}</a>
            </li>
          </ul>
          <ul className="space-y-2">
            {/* <li>
              <a href="/howtocheckin">{t("checkIn")}</a>
            </li> */}
            <li>
              <a href="/faq">{t("faq")}</a>
            </li>
            <li>
              <a href="/contact-us">{t("contactUs")}</a>
            </li>
          </ul>
        </div>
        <div className="space-y-2 sm:space-y-4">
          <p className="text-base font-normal uppercase sm:text-lg">
            {t("followUs")}
          </p>
          <div className="flex gap-2 sm:gap-4">
            <a href="https://x.com/bakhtera_corp" target="_blank">
              <TwitterIcon className="w-4 h-4 fill-white sm:h-6 sm:w-6" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100069576246376"
              target="_blank"
            >
              <FacebookIcon className="w-4 h-4 fill-white sm:h-6 sm:w-6" />
            </a>
            <a
              href="https://www.instagram.com/bigeventasia.id/"
              target="_blank"
            >
              <InstagramIcon className="w-4 h-4 fill-white sm:h-6 sm:w-6" />
            </a>
            <a
              href="https://www.linkedin.com/company/bakhtera-inovasi-gemilang-pt/"
              target="_blank"
            >
              <LinkedinIcon className="w-4 h-4 fill-white sm:h-6 sm:w-6" />
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3 border-t app-nav-container border-white/15 sm:gap-4">
        <p className="text-xs font-normal tracking-wide uppercase sm:text-sm text-white/80">
          {t("eventOwner")}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
          <div
            className="flex items-center justify-center px-4 py-3 bg-white rounded-lg cursor-pointer"
            onClick={() =>
              handleOpenNewTab(
                "https://www.instagram.com/jatelindo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
              )
            }
          >
            <img
              src={jatelindoLogo}
              alt="Jatelindo"
              className="object-contain w-auto h-7 sm:h-9"
            />
          </div>
          <div className="flex items-center justify-center px-4 py-3 bg-white rounded-lg">
            <img
              src={felloLogo}
              alt="Fello"
              className="object-contain w-auto h-7 sm:h-9"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-end gap-8 app-nav-container sm:flex-row sm:items-end">
        <div>
          <label className="relative inline-flex items-center cursor-pointer ">
            <span className="text-xs font-medium me-3 md:text-sm text-white-900 dark:text-white-300">
              ID
            </span>
            <input
              type="checkbox"
              value={isEnglish}
              checked={isEnglish}
              onChange={() => handleSwitchLanguage()}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 dark:peer-focus:ring-red-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[26px] sm:after:start-[26px] md:after:start-[28px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
            <span className="text-xs font-medium ms-3 md:text-sm text-white-900 dark:text-white-300">
              EN
            </span>
          </label>
        </div>
        <div className="text-[10px] sm:text-sm">
          <p>
            <a href="/privacy-policy">{t("privacyPolicy")}</a>
          </p>
        </div>
        <div className="text-[10px] sm:text-sm">
          <p>
            <a href="https://cloudxier.com" target="_blank">
              {moment().year()} {t("copyrightText")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
